import React from 'react';
import Footer from '../components/Footer';
import Form from '../components/pageComponents/contactPage/form';
import Navbar from '../components/Navbar';


function Contact() {
  return (
    <div>
      <Navbar/>
      <Form/>
      <Footer />
    </div>
  );
}

export default Contact;